import { Link, To } from "react-router-dom";
import cx from "classnames";
import "./NavigationItem.styles.scss";

type NavigationItemProps = {
  /**
   * Describes a location that is the destination of navigation via URL.
   */
  link: To;
  /**
   * Label text for the `link` element.
   */
  label: string;
  /**
   * Element placed left of the text node as icon.
   */
  icon?: React.ReactNode;
  /**
   * If `true`, the component is displaying as active.
   *
   * @default false
   */
  active?: boolean;
  /**
   * If `true`, the component is disabled.
   *
   * @default false
   */
  disabled?: boolean;
};

export const NavigationItem: React.FC<NavigationItemProps> = (props) => {
  const { link, label, icon, active = false, disabled = false } = props;

  return (
    <Link
      to={link}
      onClick={(e) => disabled && e.preventDefault()}
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      className={cx([
        "nb-navigation-item",
        {
          "nb-navigation-item--active": active,
          "nb-navigation-item--disabled": disabled,
        },
      ])}
    >
      {icon && <span className="nb-navigation-item-icon">{icon}</span>}
      <span className="nb-navigation-item-text">{label}</span>
    </Link>
  );
};
